import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tr } from '@utils';
import { PortalRoutePath } from '@models';
import { Grid, Stack } from '@mui/material';
import { DarkCard } from '@components/common';
import { EmptyEntityPageLayout } from '@components/portal/common';
import { GlobeIcon, CarListBandIcon } from '@components/icons';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ReactComponent as Illustration } from '@assets/illustrations/need-help.svg';

export interface IRemainingTasksLayoutProps {
	carListBandTaskCompleted?: boolean;
	locationTaskCompleted?: boolean;
}

export const RemainingTasksLayout: FC<IRemainingTasksLayoutProps> = ({ carListBandTaskCompleted, locationTaskCompleted }) => {
	const navigate = useNavigate();
	return (
		<Stack direction="column" alignItems="center" justifyContent="center" spacing={4} flexGrow={1}>
			<Grid container direction="row" spacing={4}>
				<Grid item xs={12} lg={6}>
					<DarkCard
						sx={{ flexGrow: 1, paddingY: 5 }}
						pattern="linepattern3"
						icon={<CarListBandIcon style={{ width: 48, height: 48 }} />}
						title={
							<Stack direction="row" alignItems="center">
								<Tr.Portal path="dashboard.car-list-band-card-title" />
								{carListBandTaskCompleted ? <CheckCircleIcon sx={{ color: 'success.main', marginLeft: 2 }} /> : null}
							</Stack>
						}
						subtitle={<Tr.Portal path="dashboard.car-list-band-card-content" />}
						onClick={() => navigate(`/portal/${PortalRoutePath.CAR_LIST_BANDS}`)}
					/>
				</Grid>
				<Grid item xs={12} lg={6}>
					<DarkCard
						sx={{ flexGrow: 1, paddingY: 5 }}
						pattern="linepattern4"
						icon={<GlobeIcon style={{ width: 48, height: 48 }} />}
						title={
							<Stack direction="row" alignItems="center">
								<Tr.Portal path="dashboard.locations-card-title" />
								{locationTaskCompleted ? <CheckCircleIcon sx={{ color: 'success.main', marginLeft: 2 }} /> : null}
							</Stack>
						}
						subtitle={<Tr.Portal path="dashboard.locations-card-content" />}
						onClick={() => navigate(`/portal/${PortalRoutePath.LOCATION}`)}
					/>
				</Grid>
			</Grid>
			<EmptyEntityPageLayout
				illustration={<Illustration />}
				title={<Tr.Portal path="dashboard.need-help-title" />}
				content={<Tr.Portal path="dashboard.need-help-content" />}
				addButtonText={<Tr.Portal path="dashboard.contact-us-button" />}
				addButtonProps={{ 'data-testid': 'dashboard-contact-up-button' }}
			/>
		</Stack>
	);
};
